
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.982 6.839c.29-.872.19-1.827-.273-2.62a3.225 3.225 0 00-3.474-1.547A3.19 3.19 0 007.83 1.6a3.226 3.226 0 00-3.077 2.233A3.19 3.19 0 002.621 5.38a3.226 3.226 0 00.396 3.781c-.29.872-.19 1.827.274 2.62a3.225 3.225 0 003.474 1.547A3.188 3.188 0 009.17 14.4a3.226 3.226 0 003.078-2.235 3.19 3.19 0 002.133-1.546 3.226 3.226 0 00-.398-3.78zm-4.81 6.724a2.39 2.39 0 01-1.536-.555c.02-.01.053-.029.075-.042l2.549-1.473a.414.414 0 00.21-.362V7.537l1.077.622c.011.006.02.017.02.03v2.976a2.402 2.402 0 01-2.396 2.399zm-5.155-2.2a2.388 2.388 0 01-.286-1.608c.02.011.052.032.076.045l2.549 1.472c.13.076.29.076.419 0l3.111-1.797v1.244a.04.04 0 01-.015.034L7.295 12.24a2.402 2.402 0 01-3.277-.878zm-.67-5.564a2.39 2.39 0 011.248-1.052l-.001.088v2.944c0 .15.08.289.21.363l3.11 1.796-1.076.622a.038.038 0 01-.037.003L4.224 9.075a2.402 2.402 0 01-.878-3.276zm8.85 2.06L9.086 6.06l1.077-.621a.038.038 0 01.036-.003l2.577 1.487a2.4 2.4 0 01-.37 4.329V8.221a.414.414 0 00-.208-.363zm1.072-1.614a3.457 3.457 0 00-.075-.046l-2.55-1.472a.415.415 0 00-.418 0L7.114 6.524V5.28a.04.04 0 01.016-.033L9.706 3.76a2.399 2.399 0 013.563 2.485zM6.53 8.462L5.45 7.84a.038.038 0 01-.02-.03V4.834a2.4 2.4 0 013.933-1.842c-.02.01-.053.03-.075.043L6.74 4.507a.414.414 0 00-.21.362L6.53 8.461zM7.114 7.2L8.5 6.4l1.386.8v1.6L8.5 9.6l-1.386-.8V7.2z","fill":"#000"}})])
          )
        }
      }
    